import { AccountInfoFooter } from './AccountInfoFooter';
import { withI18n } from 'react-i18next';

export default withI18n()(AccountInfoFooter);
